import { Group, Paper, Text, ThemeIcon } from '@mantine/core'
import { ReactNode } from 'react'

export function StatusRow({
  icon,
  label,
  description,
  action,
  color,
}: {
  icon: ReactNode
  label: string
  description: string | null
  action: ReactNode
  color?: string
}) {
  return (
    <Paper withBorder p="md" radius="md">
      <Group justify="space-between">
        <Group gap="sm">
          <ThemeIcon size="lg" color={color}>
            {icon}
          </ThemeIcon>
          <div>
            <Text fw={700}>{label}</Text>
            <Text size="xs" c="dimmed">
              {description}
            </Text>
          </div>
        </Group>
        {action}
      </Group>
    </Paper>
  )
}
